/* eslint-disable */
import styles from './index.module.scss'
import { Close, SmsOrange, Timer } from '../../../icons'
import { GeneralInput } from '../input'
import { FormButton } from '../button'
import { useState, useEffect, useContext } from 'react'
import { PageContext } from '../../../context/PageContextProvider'
import VerifyAPI from '../../../api/verify'
import GIF from '../../../assets/images/load.gif'
import translate from '../../../utils/translate.json'

const Module = ({ setModule, click, setVerify, email, verify }) => {
  const { language } = useContext(PageContext)
  const [minutes, setMinutes] = useState(3)
  const [seconds, setSeconds] = useState(0)
  const [load, setLoad] = useState(false)
  const [code, setCode] = useState('')
  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval)
          setCode('')
        } else {
          setMinutes(minutes - 1)
          setSeconds(59)
        }
      }
    }, 1000)
    return () => {
      clearInterval(myInterval)
    }
  })
  useEffect(() => {
    (async () => {

    const min = 100000
    const max = 999999
    const num = Math.floor(Math.random() * min) + max
    await setCode(num)
    const res = await VerifyAPI.insert({ email: email, code: num.toString() })
    if (res.status === 200) {
      await setLoad(true)
    }
  
    })();
  }, [])
  const handleVerify = async () => {
    await setLoad(false)
    const min = 100000
    const max = 999999
    const num = Math.floor(Math.random() * min) + max
    await setCode(num)
    const res = await VerifyAPI.insert({ email: email, code: num.toString() })
    if (res.status === 200) {
      await setMinutes(3)
      await setLoad(true)
    }
  }

  return load ? (
    <div className={styles.container}>
      <Close onClick={click} />
      <span>
        <SmsOrange />
      </span>
      <p>{translate['email_verification'][language]}</p>
      <p>{translate['check_spam'][language]}</p>
      <GeneralInput
        id="module-code"
        type="text"
        placeholder={translate['verification_code'][language]}
        style={
          verify ? { border: '1px solid red' } : { border: '1px solid #C5CEE0' }
        }
      />
      <div>
        {minutes === 0 && seconds === 0 ? (
          <button
            onClick={() => {
              handleVerify()
            }}
          >
            {translate.resend[language]}
          </button>
        ) : (
          <button>
            <Timer /> {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
          </button>
        )}
        <FormButton
          onClick={() => {
            if (code == document.getElementById('module-code').value.trim()) {
              setVerify(true)
              click()
            } else {
              setVerify(false)
            }
          }}
        >
          {translate.confirm[language]}
        </FormButton>
      </div>
    </div>
  ) : (
    <div className={styles.container}>
      <h1>{email}</h1>
      <img src={GIF} alt="Loading..." />
    </div>
  )
}

export { Module }
